import { paramCase } from 'change-case'
import { oneOf, string, array, func, bool } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import { MobileSingle } from './display'
import { baseStyles } from './styles'

const displays = {
  mobileSingle: MobileSingle,
  default: MobileSingle,
}

const matchDisplay = (display) => displays[display] || displays.default

export const SMS = ({
  accountName,
  assets,
  content,
  display,
  isPresenting = false,
  onExpandAsset = () => null,
  onRemoveAsset = () => null,
  readOnly = false,
  updateText = () => null,
}) => {
  const RenderDisplay = matchDisplay(display)

  return (
    <div
      css={baseStyles(display)}
      className={kuiperClassNames(
        'sms-message sms-message-sms',
        `sms-message-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountName={accountName}
        asset={assets[0]}
        content={content}
        display={display}
        isPresenting={isPresenting}
        readOnly={readOnly}
        onContentChange={(val) => updateText(val, 'content')}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
      />
    </div>
  )
}

SMS.propTypes = {
  accountName: string,
  assets: array,
  content: string,
  display: oneOf(['mobileSingle']),
  isPresenting: bool,
  onExpandAsset: func,
  onRemoveAsset: func,
  readOnly: bool,
  updateText: func,
}
